import PropTypes from 'prop-types';
import { useCheckbox } from 'react-aria';
import { useToggleState } from 'react-stately';
import { useRef } from 'react';
import { uniqueId } from 'lodash';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Checkbox.module.scss';

const Checkbox = (props) => {
    const { id } = props;
    const ref = useRef();
    const state = useToggleState(props);
    const { inputProps } = useCheckbox(props, state, ref);

    return (
        <div
            className="govuk-checkboxes govuk-checkboxes--small"
            data-testid={props['data-testid']}
        >
            <div className="govuk-checkboxes__item">
                <input
                    {...inputProps}
                    id={id}
                    ref={ref}
                    className="govuk-checkboxes__input"
                    data-testid={props['data-testid'] ? props['data-testid'] + '-input' : null}
                />
                <label htmlFor={id}
                    {...inputProps}
                    id={id + 'label'}
                    className={['govuk-label govuk-checkboxes__label', styles.label].join(' ')}
                    data-testid={props['data-testid'] ? props['data-testid'] + '-checkbox-label' : null}
                >
                &nbsp;
                </label>
            </div>
        </div>
    );
};

Checkbox.propTypes = {
    ...defaultAriaProps,
    id: PropTypes.string.isRequired
};

Checkbox.defaultProps = {
    id: uniqueId('checkbox_')
};

export default Checkbox;
